import {useEffect, useState} from "react";

/**
 * Animates a number from 0 up to `target` (ease-out).
 * `delay` lets several counters start in a staggered way.
 */
const useCountUp = (target, duration = 1200, delay = 0) => {
    const [value, setValue] = useState(0);

    useEffect(() => {
        let frame;
        let startTime = null;

        const tick = (now) => {
            if (startTime === null) startTime = now;

            const t = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic

            setValue(Math.round(target * eased));

            if (t < 1) frame = requestAnimationFrame(tick);
        };

        const timeout = setTimeout(() => {
            frame = requestAnimationFrame(tick);
        }, delay);

        return () => {
            clearTimeout(timeout);
            cancelAnimationFrame(frame);
        };
    }, [target, duration, delay]);

    return value;
};

export default useCountUp;